import React, { Fragment } from 'react';
import { ReactComponent as CameraIcon } from 'assets/icons/camera.svg';
import { ReactComponent as SpeakerIcon } from 'assets/icons/speaker.svg';
import { ReactComponent as SignalIcon } from 'assets/icons/signal.svg';
import { ReactComponent as WifiIcon } from 'assets/icons/wifi.svg';
import { ReactComponent as BatteryIcon } from 'assets/icons/battery.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import { ReactComponent as ShareIcon } from 'assets/icons/share.svg';
import AppIcon from 'assets/images/app-icon.png';
import moment from 'moment';
import Slider from 'react-slick';

const PhonePreview = ({
  urls,
  caption,
  type,
  promoPost
}: {
  urls: string[];
  caption: string | undefined;
  type: 'video' | 'photo';
  promoPost: boolean;
}) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    waitForAnimate: false
  };
  const images = urls.some((url) => Boolean(url?.trim()))
    ? urls.filter((url) => url?.trim() !== '')
    : null;

  return (
    <div className='w-full p-8'>
      <p className='text-center text-gray-5 mb-6'>
        Here is a preview of the product you are creating
      </p>
      <div className='bg-gray-34 p-1 rounded-[30px] max-w-[226px] mx-auto relative'>
        <div className='w-[2px] bg-red-11 h-[33px] absolute top-[110px] right-[-2px] rounded-r-[2px]' />
        <div className='absolute right-5 top-[250px] z-10'>
          <SaveIcon />
          <p className='text-white text-sm'>Save</p>
        </div>
        <div className='absolute right-5 top-[310px] z-10'>
          <ShareIcon />
          <p className='text-white text-sm'>Share</p>
        </div>
        <div className='w-[2px] bg-gray-34 h-[66px] absolute top-[174px] right-[-2px] rounded-r-[2px]' />
        <div className='px-[5px] pb-[30px] rounded-[30px] border-[0.5px] border-gray-35'>
          <div className='pt-[15px] pb-[10px] relative'>
            <CameraIcon className='absolute left-[25%] top-[13px]' />
            <SpeakerIcon className='mx-auto' />
          </div>
          <div className='w-full h-[428px] rounded-[22px] overflow-hidden relative'>
            {urls.length ? (
              <Fragment>
                <div className='absolute top-2 px-2 z-10 flex items-center justify-between w-full'>
                  <span className='text-white bg-green-5 px-[6px] py-[1px] rounded-2xl shadow-md'>
                    {moment().format('HH:mm')}
                  </span>
                  <div className='flex items-center gap-1'>
                    <SignalIcon />
                    <WifiIcon />
                    <BatteryIcon />
                  </div>
                </div>
                <div className='absolute top-6 z-10 left-1/2 transform -translate-x-1/2'>
                  <img src={AppIcon} alt='' />
                </div>
                <div className='absolute px-2 bottom-4 w-full z-10'>
                  <div>
                    {caption && (
                      <p className='line-clamp-2 text-white font-bold text-sm mb-1.5'>{caption}</p>
                    )}
                    <button className='w-full h-10 border-[2px] border-white rounded-full text-white font-bold'>
                      {promoPost ? 'Start Shopping' : 'View Menu'}
                    </button>
                  </div>
                </div>
                <div className='w-full h-full'>
                  {type === 'photo' ? (
                    <React.Fragment>
                      {images ? (
                        <Slider {...sliderSettings} className='w-full h-full object-cover'>
                          {images.map((url) => (
                            <img
                              src={url}
                              key={url}
                              alt=''
                              className='w-full h-full object-cover'
                            />
                          ))}
                        </Slider>
                      ) : null}
                    </React.Fragment>
                  ) : (
                    <video className='w-full h-full object-cover' autoPlay loop key={urls?.[0]}>
                      <source src={urls?.[0]} type='video/mp4' />
                    </video>
                  )}
                </div>
              </Fragment>
            ) : (
              <div className='w-full h-full bg-white block' />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhonePreview;
